import React, { useEffect, useState } from 'react';
import './index.scss';
import { ROUTES as _routes } from '../../constants/app-constants';
import confirmingOrderImg from '../../../assets/images/ordering_img.svg';
import confirmingOrderDinein from '../../../assets/images/confirmingOrderDinein.svg';
import preparingOrderImgDelivery from '../../../assets/images/preparingOrderDelivery.svg';
import preparingOrderImgDinein from '../../../assets/images/preparingOrderDinein.svg';
import onTheWayImg from '../../../assets/images/Feedback/on_the_way.png';
import onTheWayDinein from '../../../assets/images/onTheWayDinein.svg';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

const DeliveryOTP = ({ data, theme, onHide }) => {
  const [isVisible, setIsVisible] = useState(true);
  const history = useHistory();
  useEffect(() => {
    if (data?.status === 'PICKEDUP') {
      const timer = setTimeout(() => {
        setIsVisible(false);
        if (onHide) onHide(data.status);
      }, 60000);

      return () => clearTimeout(timer);
    }
  }, [data, onHide]);

  const handleClose = () => {
    setIsVisible(false);
    if (onHide) onHide(data.status);
  };

  const handleRecentOrderClick = () => {
    if (data?.id) {
      const path = {
        pathname: _routes.RECENT_ORDERS,
        state: { id: data.id }
      };
      history.push(path);
    }
  };
  if (!isVisible) return null;

  const renderMessage = () => {
    const { status } = data || {};

    switch (status) {
      case 'PENDING':
        return (
          <>
            <div className="delivery-status-banner__message">
              <div className="delivery-status-banner__message--status">
                CONFIRMING YOUR ORDER
              </div>
              <div className="delivery-status-banner__message--info">
                Your order has been received.
              </div>
            </div>
            <img
              src={
                theme === 'delivery'
                  ? confirmingOrderImg
                  : confirmingOrderDinein
              }
              alt="Confirming order"
              className="delivery-status-banner__image"
            />
          </>
        );
      case 'ACCEPTED':
      case 'PREPARED':
        return (
          <>
            <div className="delivery-status-banner__message">
              <div className="delivery-status-banner__message--status">
                PREPARING YOUR ORDER
              </div>
              <div className="delivery-status-banner__message--info">
                Your order will be ready shortly.
              </div>
            </div>
            <img
              src={
                theme === 'delivery'
                  ? preparingOrderImgDelivery
                  : preparingOrderImgDinein
              }
              alt="Preparing order"
              className="delivery-status-banner__image"
            />
          </>
        );
      case 'DISPATCHED':
      case 'RIDER_ALLOCATED':
        return (
          <>
            <div className="delivery-status-banner__message">
              <div>
                <div className="delivery-status-banner__message--status">
                  ON THE WAY
                  <span>
                    {' > '}
                    <span
                      className="delivery-status-banner__message--info"
                      style={{ margin: '0rem 0rem 0rem 0.5rem' }}
                    >
                      Your order will reach you shortly.
                    </span>
                  </span>
                </div>
              </div>
              {renderDeliveryPin()}
            </div>
            <img
              src={theme === 'delivery' ? onTheWayImg : onTheWayDinein}
              alt="On the way"
              className="delivery-status-banner__image"
            />
          </>
        );
      case 'PICKEDUP':
        return (
          <>
            <div className="delivery-status-banner__message">
              <div className="delivery-status-banner__message--status">
                Order Completed
              </div>
              <div className="delivery-status-banner__message--info">
                Thank you, order again.
              </div>
            </div>
            <img
              src={theme === 'delivery' ? onTheWayImg : onTheWayDinein}
              alt="Picked up"
              className="delivery-status-banner__image"
            />
          </>
        );
      default:
        return (
          <span className="delivery-status-banner__message--status">
            Status not available
          </span>
        );
    }
  };

  const renderDeliveryPin = () => {
    const { status, rider_details } = data || {};
    if (
      status === 'DISPATCHED' ||
      (status === 'RIDER_ALLOCATED' && data?.delivery_pin)
    ) {
      return rider_details ? (
        <div className="delivery-status-banner__message--info">
          Delivery Pin: {data?.delivery_pin}
        </div>
      ) : null;
    }
    return null;
  };

  return (
    <div
      className={`delivery-status-banner ${
        theme === 'delivery'
          ? 'delivery-status-banner--delivery'
          : 'delivery-status-banner--dinein'
      }`}
      onClick={handleRecentOrderClick}
    >
      {renderMessage()}
      <button
        className="delivery-status-banner__close"
        onClick={event => {
          event.stopPropagation();
          handleClose();
        }}
      >
        &times;
      </button>
    </div>
  );
};

export default DeliveryOTP;
